export const generateFinancialYears = () => {
    const years = [];
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1-12
    // FY runs Apr–Mar. If we're in Apr–Dec, current FY starts this year; else last year.
    const currentFYStart = currentMonth >= 4 ? currentYear : currentYear - 1;
    for (let i = 0; i <= 4; i++) {
        const start = currentFYStart - i;
        const end = start + 1;
        years.push({
            value: `${start}-${end}`,
            label: `FY ${start}-${String(end).slice(2)}`,
            fromDate: `${start}-04-01`,
            toDate: `${end}-03-31`,
        });
    }
    return years;
};

export const FINANCIAL_YEARS = generateFinancialYears();

export const fmt = (n) =>
    n == null
        ? '—'
        : Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Signed formatter: positive => "1,234.56 Dr", negative => "1,234.56 Cr", zero => "0.00"
export const fmtSigned = (n) => {
    if (n == null) return '—';
    const num = Number(n);
    if (num === 0) return '0.00';
    return `${fmt(Math.abs(num))} ${num > 0 ? 'Dr' : 'Cr'}`;
};

// Recoverable backend errors that should render inline on the form rather
// than as a generic "something went wrong"
export const isRecoverableError = (msg) => {
    if (!msg) return false;
    return /not found for society|not a leaf account|group account .* not found/i.test(msg);
};
